<!--教科研菜单-->
<template>
    <div class="menu-wrap">
        <div class="menu-container">
            <div @click="changeItem('1','0')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">课题引领</div>
            <div @click="changeItem('2','0')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">教研赛事</div>
            <div @click="changeItem('3','0')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">专题活动</div>
            <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">成果展示</div>
        </div>
        <!--课题引领子项-->
        <div v-if="activeItem==='1'" class="child-menu-container">
            <div @click="changeItem('1','0')" :class="activeChildItem==='0'?'child-menu-item child-menu-active':'child-menu-item'">全部</div>
            <div @click="changeItem('1','1')" :class="activeChildItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">进行中</div>
            <div @click="changeItem('1','2')" :class="activeChildItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">已结束</div>
            <div @click="changeItem('1','3')" :class="activeChildItem==='3'?'child-menu-item child-menu-active':'child-menu-item'">已发布</div>
        </div>
        <!--教研赛事子项-->
        <div v-if="activeItem==='2'" class="child-menu-container">
            <div @click="changeItem('2','0')" :class="activeChildItem==='0'?'child-menu-item child-menu-active':'child-menu-item'">全部</div>
            <div @click="changeItem('2','1')" :class="activeChildItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">进行中</div>
            <div @click="changeItem('2','2')" :class="activeChildItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">已结束</div>
        </div>
        <!--专题活动子项-->
        <div v-if="activeItem==='3'" class="child-menu-container">
            <div @click="changeItem('3','0')" :class="activeChildItem==='0'?'child-menu-item child-menu-active':'child-menu-item'">全部</div>
            <div @click="changeItem('3','1')" :class="activeChildItem==='1'?'child-menu-item child-menu-active':'child-menu-item'">进行中</div>
            <div @click="changeItem('3','2')" :class="activeChildItem==='2'?'child-menu-item child-menu-active':'child-menu-item'">已结束</div>
        </div>
    </div>
</template>

<script>

export default {
    name:'teachResearchMenu',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:this.itemNum,
            activeChildItem:"0",
        }
    },
    methods: {
        changeItem(item,childItem){
            this.activeChildItem = childItem;
            this.activeItem = item;
            this.$emit('change-item', item,childItem );
        },
    }
}

</script>

<style scoped>
.menu-wrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 24px;
}
.menu-container{
    display: inline-flex;
    align-items: center;
    gap: 16px;
    flex-shrink: 0;
}
.menu-item{
    height: 38px;
    line-height: 38px;
    padding: 0 22px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    color: #1f5aa8;
    background: #fff;
    border: 1px solid #bfd8f2;
    border-radius: 19px;
    cursor: pointer;
    white-space: nowrap;
}
.menu-active{
    background: #0d55a4;
    border-color: #0d55a4;
    color: #fff;
}
/*课题引领子项*/
.child-menu-container{
    display: inline-flex;
    align-items: center;
    gap: 10px;
}
.child-menu-item{
    height: 30px;
    line-height: 30px;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: center;
    font-size: 14px;
    color: #1f5aa8;
    background: #fff;
    border: 1px solid #bfd8f2;
    border-radius: 15px;
    cursor: pointer;
    white-space: nowrap;
}
.child-menu-active{
    background: #0d55a4;
    border-color: #0d55a4;
    color: #fff;
}
</style>
